import { useEffect, useState } from "react";
import "dayjs/locale/pt-br";
import {
  Outlet,
  useBlocker,
  useNavigate,
  useOutletContext,
} from "react-router-dom";
import {
  Breadcrumbs,
  Button,
  IconButton,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
  Zoom,
} from "@mui/material";
import api from "../../services/api";
import NewAlertModal from "../../componentes/newAlertModal";
import { useNotification } from "../../componentes/notificationProvider";
import { ArrowBack } from "@mui/icons-material";
import { Box } from "@mui/system";

export default function Configuracoes() {
  const [subTitle, setSubTitle] = useState("");
  const [changes, setChanges] = useState(null);
  const [rerender, setRerender] = useState(true);
  const [settings, setSettings] = useState([]);
  const [openAlertModal, setOpenAlertModal] = useState(false);
  const [isFilterEditor, setIsFilterEditor] = useState<boolean>(false);
  const [pageId, setPageId] = useState<string | null>(null);
  const [isEditingDataSource, setIsEditingDataSource] =
    useState<boolean>(false);
  const context = useOutletContext();
  const theme = useTheme();
  const navigate = useNavigate();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const sm = useMediaQuery(theme.breakpoints.up("sm"));

  const notify = useNotification();
  const blocker = useBlocker((args) => {
    return (
      args.currentLocation.pathname !== args.nextLocation.pathname && !!changes
    );
  });
  const styles = {
    changeAlert: {
      position: "absolute",
      bottom: 20,
      left: 0,
      right: 0,
    },
    changeAlertCard: {
      borderRadius: "5px",
      padding: "5px 15px",
      width: { xs: "95%", md: "650px" },
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
    titleAndLinkPage: {
      flexGrow: 1,
      fontWeight: 400,
      fontSize: "1.25rem",
      // mt: 1,
      // mb: 2,
    },
    text: {
      fontSize: "0.875rem",
      color: theme.palette.text.primary,
      fontWeight: 400,
    },
    breadcrumbs: {},
  };

  useEffect(() => {
    handleGetSettings();
    permissionValidate();
  }, []);

  useEffect(() => {
    if (blocker.state === "blocked") {
      setOpenAlertModal(true);
    }
  }, [blocker]);

  // requisições a api
  async function permissionValidate() {
    try {
      const response = await api.get("/authPermissionClient");

      if (response.data.message !== "Permission is valid") {
        navigate("/");
      }
    } catch (error: any) {
      console.error(error);
      notify(error.status, undefined, "error", error);

      navigate("/");
    }
  }
  async function handleGetSettings() {
    try {
      const response = await api.get("/admin/findMany");

      setSettings(response.data);
    } catch (error: any) {
      console.error(error);
      notify(error.status, error.response?.data?.message, "error");
    }
  }

  function clearChanges() {
    setChanges(null);
    setRerender(!rerender);
  }

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "start",
          alignItems: "center",
          padding: 2,
          gap: 1,
        }}
      >
        {(isFilterEditor && pageId) || isEditingDataSource ? (
          <IconButton
            sx={{ color: theme.palette.text.primary }}
            onClick={() => {
              if (isFilterEditor && isFilterEditor === true && pageId) {
                setIsFilterEditor(false);
                navigate(`/configuracoes/filtros/${pageId}`);
              }
              if (isEditingDataSource && isEditingDataSource === true) {
                setIsEditingDataSource(false);
                navigate("/configuracoes/datasource");
              }
            }}
          >
            <ArrowBack />
          </IconButton>
        ) : null}
        <Breadcrumbs
          separator={<Typography sx={styles.titleAndLinkPage}>/</Typography>}
          sx={styles.breadcrumbs}
        >
          <Typography sx={styles.titleAndLinkPage}>Configurações</Typography>
          <Typography
            sx={{
              ...styles.titleAndLinkPage,
              color: theme.palette.text.primary,
            }}
          >
            {subTitle}
          </Typography>
        </Breadcrumbs>
      </Box>

      <Outlet
        key={"ouT" + rerender}
        context={{
          setChanges,
          setSubTitle,
          ...(context || {}),
          settings,
          setIsFilterEditor,
          setPageId,
          setIsEditingDataSource,
        }}
      />

      <NewAlertModal
        openModal={openAlertModal}
        setOpenModal={setOpenAlertModal}
        buttonText={"Salvar"}
        buttonCancelText={"Voltar"}
        confirmar={false}
        handleButton={() => {
          //handleUpdateSettings();
          setOpenAlertModal(false);
          setChanges(null);
          blocker.proceed && blocker.proceed();
        }}
        handleCancel={() => {
          setOpenAlertModal(false);
          blocker.reset && blocker.reset();
        }}
        severity={"warning"}
        singleButton={false}
        //textContent={`Você tem alterações não salvas em ${changes?.product} , deseja salvar?`}
      />

      {/*  {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )} */}
    </>
  );
}
